import { render } from "./PhoneConfirmation.vue?vue&type=template&id=36f48588&scoped=true"
import script from "./PhoneConfirmation.vue?vue&type=script&lang=js"
export * from "./PhoneConfirmation.vue?vue&type=script&lang=js"

import "./PhoneConfirmation.vue?vue&type=style&index=0&id=36f48588&lang=css"
import "./PhoneConfirmation.vue?vue&type=style&index=1&id=36f48588&scoped=true&lang=scss"
import "./PhoneConfirmation.vue?vue&type=style&index=2&id=36f48588&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f48588"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QField,QInput});
